import { Link } from "react-router-dom";

function BottomFooter() {
    return (
        <div className="bottom-section">
            <Link to="/">
                <div className="logo-bottom">
                    <img src="logo.png" alt="CHI BRANDER INC Logo"/>
                </div>
                <div className="company-name-bottom">CHI BRANDER INC</div>
            </Link>
        </div>
    );
}

export default BottomFooter;